import {
    LexicalComposer,
} from '@lexical/react/LexicalComposer';
import {RichTextPlugin} from '@lexical/react/LexicalRichTextPlugin';

import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {HistoryPlugin} from '@lexical/react/LexicalHistoryPlugin';
import {ListPlugin} from '@lexical/react/LexicalListPlugin';

import {HeadingNode, QuoteNode} from '@lexical/rich-text';
import {ListNode, ListItemNode} from '@lexical/list';
import {ParagraphNode, TextNode} from 'lexical';
import {LineBreakNode} from 'lexical';

import {SerializedEditorState} from 'lexical';
import {LexicalErrorBoundary} from "@lexical/react/LexicalErrorBoundary";

interface RichTextViewerProps {
    initialJson: SerializedEditorState;
}

export function RichTextViewer({initialJson}: RichTextViewerProps) {
    const editorConfig = {
        namespace: 'Viewer',
        editable: false,
        theme: {},
        onError: (e: unknown) => console.error(e),
        nodes: [
            ParagraphNode,
            TextNode,
            HeadingNode,
            QuoteNode,
            ListNode,
            ListItemNode,
            LineBreakNode
        ],

        editorState: (editor) => {
            try {
                const serialized = typeof initialJson === "string"
                    ? initialJson
                    : JSON.stringify(initialJson);

                const parsed = editor.parseEditorState(serialized);
                editor.setEditorState(parsed);
            } catch (error) {
                console.error("Failed to parse editor state, using empty doc", error);
                editor.setEditorState(
                    editor.parseEditorState(
                        JSON.stringify({
                            root: {
                                children: [],
                                direction: "ltr",
                                format: "",
                                indent: 0,
                                type: "root",
                                version: 1,
                            },
                        })
                    )
                );
            }
        },


    };

    console.log("Root node types:");
    logNodeTypes(initialJson.root);

    return (
        <div className="flex flex-col h-full w-full">
            
            <LexicalComposer initialConfig={editorConfig}>
                <div className="flex-1 w-full overflow-auto prose prose-sm sm:prose lg:prose-lg max-w-none text-gray-900">
                    <RichTextPlugin
                        contentEditable={
                            <ContentEditable className="
                                [&_h1]:text-2xl 
                                [&_h1]:font-bold
                                [&_h2]:text-xl [&_h2]:font-semibold
                                [&_h3]:text-lg
                                [&_ul]:list-disc 
                                [&_ol]:list-decimal 
                                [&_li]:ml-6
                            outline-none"/>
                        }
                        placeholder={null}
                        ErrorBoundary={LexicalErrorBoundary}/>
                    <HistoryPlugin/>
                    <ListPlugin/>
                </div>
            </LexicalComposer>
        </div>
    );
}


function logNodeTypes(node: any) {
    if (node && typeof node === 'object') {
        if (node.type) console.log("Node type:", node.type);
        if (node.children) node.children.forEach(logNodeTypes);
    }
}